import { useRef } from 'react';

export const useThrottleAsyncFn = (fn: () => Promise<void>, delay = 3000) => {
  const isRunning = useRef(false);
  const lastCalled = useRef<number>(0);

  return async () => {
    const now = Date.now();
    if (isRunning.current || now - lastCalled.current < delay) return;

    isRunning.current = true;
    lastCalled.current = now;

    try {
      await fn();
    } finally {
      isRunning.current = false;
    }
  };
};
